export default "__VITE_ASSET__DfRMMt1b__"